import LoginSmsCode from './LoginSmsCode';

export default LoginSmsCode;